<template>
 <div class="side_box">
                    <h4 class="content-subtitle">Low subparts</h4>
                    <div class="table table--home">
                        <div class="table--header">
                            <div class="table--row">
                                <div class="cell">REF</div>
                                <div class="cell">Quantity</div>
                            </div>
                        </div>
                        <div class="table--body">
                            <div class="table--row">
                                <div class="cell">03-9001</div>
                                <div class="cell">12</div>
                            </div>
                            <div class="table--row">
                                <div class="cell">03-9002</div>
                                <div class="cell">2</div>
                            </div>
                            <div class="table--row">
                                <div class="cell">03-9003</div>
                                <div class="cell">5</div>
                            </div>
                            <div class="table--row">
                                <div class="cell">03-9021</div>
                                <div class="cell">5</div>
                            </div>
                            <div class="table--row">
                                <div class="cell">03-9021</div>
                                <div class="cell">5</div>
                            </div>
                        </div>
                    </div>
                </div>
</template>

<script>
export default {
  computed: {
    style() {
      return 'height: ' + this.height + '%';
    }
  },
  props: {
    height: String
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/home.scss";
@import "@/style/components/content.scss";
@import "@/style/components/sideBoxV2.scss";
@import "@/style/components/lowsubpartTable.scss";

.side_box {
  max-height: 440px;
}
</style>
